import { Suspense } from 'react'
import { Outlet } from 'react-router'

import { Fallback } from '../Fallback'

export const RouterOutlet = () => {
  return (
    <Suspense fallback={<Fallback />}>
      <Outlet />
    </Suspense>
  )
}
